import React, { createContext, useState, useContext } from 'react';

const LastClickedTickerContext = createContext();

/**
 * LastClickedTickerProvider
 *
 * Tracks the last ticker clicked from Screener or Watchlist tables.
 * Used to provide default ticker for dynamic widgets.
 *
 * Also tracks the last clicked options contract for dynamic options widgets.
 * Contract structure: { option_type: 'call'|'put', strike: number, expiration: 'YYYY-MM-DD' }
 */
export const LastClickedTickerProvider = ({ children }) => {
  const [lastClickedTicker, setLastClickedTicker] = useState('SPY');
  const [lastClickedContract, setLastClickedContract] = useState(null);

  return (
    <LastClickedTickerContext.Provider value={{
      lastClickedTicker,
      setLastClickedTicker,
      lastClickedContract,
      setLastClickedContract
    }}>
      {children}
    </LastClickedTickerContext.Provider>
  );
};

/**
 * useLastClickedTicker Hook
 *
 * Access the last clicked ticker state and setter
 */
export const useLastClickedTicker = () => {
  const context = useContext(LastClickedTickerContext);
  if (!context) {
    throw new Error('useLastClickedTicker must be used within LastClickedTickerProvider');
  }
  return context;
};
